import development from './development';
import production from './production';

const config =
  process.env.NODE_ENV === 'development' ? development : production;

export default config;
